export type ComputeBankDetailsFormValidityArgs = {
  hasFormLabels: boolean
  hasSelectedFile: boolean
  formikValid: boolean
  formikDirty: boolean
  isPostLoading: boolean
  isFileValid?: boolean
  requireDocumentDateConfirmation: boolean
  documentDateConfirmed: boolean
}

export function computeBankDetailsFormValidity({
  hasFormLabels,
  hasSelectedFile,
  formikValid,
  formikDirty,
  isPostLoading,
  isFileValid = true,
  requireDocumentDateConfirmation,
  documentDateConfirmed,
}: ComputeBankDetailsFormValidityArgs): boolean {
  const baseValid = hasFormLabels
    ? hasSelectedFile && formikValid && formikDirty && !isPostLoading && isFileValid
    : hasSelectedFile && !isPostLoading && isFileValid
  return baseValid && (!requireDocumentDateConfirmation || documentDateConfirmed)
}
